/**
 * ! The server actions below are used to fetch the static data from the fake-db. If you're using an ORM
 * ! (Object-Relational Mapping) or a database, you can swap the code below with your own database queries.
 */

'use server'

// Data Imports
import { db as profileData } from '@/fake-db/pages/userProfile'
import { db as pricingData } from '@/fake-db/pages/pricing'
import { db as protectPricingData } from '@/fake-db/pages/pricingProtect'
import { db as insightsPricingData } from '@/fake-db/pages/pricingInsights'
import { db as discoverPricingData } from '@/fake-db/pages/pricingDiscover'
import { db as pricingTestData } from '@/fake-db/pages/pricingTest'
import { db as protectApiData } from '@/fake-db/pages/protectApis'
import { db as vectaXUserData } from '@/fake-db/apps/vectaxusage'
import { db as featuresConfigDevData } from '@/fake-db/apps/featuresConfig'
import { db as featuresConfigProdData } from '@/fake-db/apps/featuresConfigProduction'

export const getProfileData = async () => {
  return profileData
}

export const getPricingData = async () => {
  if (process.env.PRICING_TEST_MODE == 'true') {
    return pricingTestData
  } else {
    return pricingData
  }
}

export const getProtectPricingData = async () => {
  if (process.env.PRICING_TEST_MODE == 'true') {
    return protectPricingData
  } else {
    return protectPricingData
  }
}

export const getInsightsPricingData = async () => {
  if (process.env.PRICING_TEST_MODE == 'true') {
    return insightsPricingData
  } else {
    return insightsPricingData
  }
}

export const getDiscoverPricingData = async () => {
  if (process.env.PRICING_TEST_MODE == 'true') {
    return discoverPricingData
  } else {
    return discoverPricingData
  }
}

export const getProtectApiRequestData = async () => {
  return protectApiData
}

export const getVectaXUserData = async () => {
  return vectaXUserData
}

export const getFeaturesConfigData = async () => {
  if (process.env.ALLFEATURES_ENABLED == 'false') {
    console.log('Production mode-> disabling all features except Vectax')
    return featuresConfigProdData
  }

  console.log('Development mode-> enabling all features')
  return featuresConfigDevData
}
